module.exports = __webpack_public_path__ + "static/media/monet-12.e50c3de3.jpeg";